module.exports = __webpack_public_path__ + "static/media/han_logo.178c2e1f.svg";